module.exports = __webpack_public_path__ + "img/ch_step_operate_video.04b3452b.png";